export const iconFontAwesomeMapsSignsPost = (
	<i className="fa-solid fa-signs-post"></i>
);
